import { Theme } from '@cambridgeassessment/cambridge-ui';
import { OrgUserStatus } from 'src/types';

export const getColor = (theme: Theme, status: OrgUserStatus): string => {
  if (status === OrgUserStatus.Active) {
    return theme.palette.success.main;
  }
  if (status === OrgUserStatus.Inactive) {
    return theme.palette.error.main;
  }
  return theme.palette.neutral.dark;
};
